import { StepProperties, TargetStepsDataProperties, TargetTypes } from './programTargetsProperties';
import { TargetSessionStatuses } from './sessionsProperties';

interface TargetSessionProperties {
	sessionId: string;
	targetId: string;
}

export interface BehaviorsProperties {
	behaviorId: string;
	sessionId: string;
}

export interface TargetResponseProperties {
	promptCodeId: string;
	responseId: string;
}

export interface GetSessionTrialsInfoProperties extends TargetSessionProperties {
	type: TargetTypes;
}

export interface TargetDTTSessionProperties extends TargetSessionProperties {
	promptCodeId: string;
}

export interface TargetTASessionProperties extends TargetSessionProperties {
	responses: StepProperties[];
}

export type GetFrequencyProperties = BehaviorsProperties;

export type SaveFrequencyProperties = BehaviorsProperties;
export interface UpdateFrequencyProperties extends BehaviorsProperties {
	count: number;
}

export interface DurationProperties {
	behaviorReductionId: string;
	createdAt: string;
	duration: string;
	id: string;
}
export type GetDurationProperties = BehaviorsProperties;
export interface SaveDurationProperties extends BehaviorsProperties {
	seconds: number;
}
export interface DeleteDurationProperties extends BehaviorsProperties {
	recordId: string;
}

interface StepsProperties extends TargetStepsDataProperties {
	id: string;
}

export interface SessionTrialProperties {
	correctPercentage: number;
	independent: number;
	prompt: number;
	trials: number;
}

export interface SessionTargetsProperties extends SessionTrialProperties {
	program: {
		id: string;
		name: string;
	};
	skillArea: {
		id: string;
		name: string;
	};
	target: {
		id: string;
		name: string;
		sd: string;
		status: number;
		steps: StepsProperties[];
		targetInstructions: string;
		type: number;
	};
	targetStatus: TargetSessionStatuses;
}

export interface UpdatePromptsProperties {
	data: TargetResponseProperties[];
	targetId: string;
}

export interface PromptCodeProperties {
	abbreviation: string; // "I","P"
	id: string;
	name: string; // "Independent", "Prompt"
}

export enum SoapNotesStatuses {
	'draft',
	'submitted',
	'expired48',
	'expiredWeek',
	'unlocked',
	'pendingBT',
}
